const loadBrowserSdks = (sdks, appState) => {
    const win = window;
    win.dynamic = win.dynamic || {};
    const scriptTag = document.createElement('script');
    const defaultHost = //ToDo: expose an option for dev and staging from the wrapper, and fallback to host selection, and default to production otherwise
     /localhost:9000/.test(location === null || location === void 0 ? void 0 : location.host)
        ? 'http://localhost:3000'
        : /pulse-react-demo\.stage\.picsart\.tools$/.test(location === null || location === void 0 ? void 0 : location.host) || /localhost:3000/.test(location === null || location === void 0 ? void 0 : location.host)
            ? 'https://pulse-server-dev.picsartstage2.com'
            : /picsartstage2\.com$/.test(location === null || location === void 0 ? void 0 : location.host) || /localhost/.test(location === null || location === void 0 ? void 0 : location.host)
                ? 'https://picsartstage2.com'
                : 'https://picsart.com';
    const host = defaultHost;
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.src = `${host}/pulse/${appState.app}/pulse.js?include=${sdks.join(',')}`;
    return new Promise((resolve, reject) => {
        scriptTag.onload = resolve;
        scriptTag.onerror = reject;
        document.head.appendChild(scriptTag);
    });
};
export { loadBrowserSdks };
//# sourceMappingURL=core-loader.js.map